import Randomizer from "../../../../src/docs/components/randomizer";
import ClientRandomizer from "../../../../src/docs/components/clientrandomizer";
import MillsCard from "../../../../src/docs/components/millscard";
import Zoom from 'react-reveal/Zoom';
import ben from "../../../../src/docs/assets/profiles/ben-stevenson.jpg";
import frank from "../../../../src/docs/assets/profiles/frank-liszt.jpg";
import domonic from "../../../../src/docs/assets/profiles/dominic.jpg";
import judanna from "../../../../src/docs/assets/profiles/judanna.jpg";
import thomas from "../../../../src/docs/assets/profiles/thomas.jpg";
import tony from "../../../../src/docs/assets/profiles/tony.jpg";
import vedrana from "../../../../src/docs/assets/profiles/vedrana.jpg";
import * as React from 'react';
export default {
  Randomizer,
  ClientRandomizer,
  MillsCard,
  Zoom,
  ben,
  frank,
  domonic,
  judanna,
  thomas,
  tony,
  vedrana,
  React
};